import { render, staticRenderFns } from "./merchant-project.vue?vue&type=template&id=6f28f39e&scoped=true"
import script from "./merchant-project.vue?vue&type=script&lang=js"
export * from "./merchant-project.vue?vue&type=script&lang=js"
import style0 from "./merchant-project.vue?vue&type=style&index=0&id=6f28f39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28f39e",
  null
  
)

export default component.exports